module.exports = __webpack_public_path__ + "static/img/rightDownOne.78f0216.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/matrixImg/rightDownOne.png
// module id = n8Xp
// module chunks = 0